import Button from "../button/Button";
import "./projectCard.css";
import React from "react";

export default function ProjectCard({
    title,
    description,
    image,
    imageAlt = "",
    countryFlag,
    countryName = "",
    tools = [],
    projectUrl = "#",
    layout = "default",
}) {

    return (
    <article className={`project-card project-card--${layout}`}>
        <div className="project-card-content">
        <div className="project-card-text">
            <div className="project-title-row">
                <h3>{title}</h3>
                {countryFlag && (
                <span className="project-country-flag">
                    <img
                    src={countryFlag}
                    alt={countryName ? `${countryName} flag` : "Project country flag"}
                    />
                </span>
                )}
            </div>

            <p>{description}</p>

            {tools.length > 0 && (
            <div className="project-tools">
                <span>Tools:</span>

                <div className="project-tool-icons">
                {tools.map((tool, index) => (
                    <span
                    className="project-tool"
                    key={index}
                    data-tooltip={tool.name}
                    aria-label={tool.name}
                    >
                    <img src={tool.icon} alt={tool.name} />
                    </span>
                ))}
                </div>
            </div>
            )}

            <Button href={projectUrl} target="_blank">View Project</Button>
        </div>

        </div>
        {image && (
        <div className="project-card-image">
            <img src={image} alt={imageAlt} />
        </div>
        )}
    </article>
    );
}